document.addEventListener("click", function (e) {
  var swatch = e.target.closest(".cart-drawer-card__swatch");
  if (!swatch || !swatch.dataset.variantId) return;

  var card = swatch.closest(".cart-drawer-card");
  if (!card) return;

  // Active state
  card.querySelectorAll(".cart-drawer-card__swatch").forEach(function (el) {
    el.classList.remove("cart-drawer-card__swatch--active");
  });
  swatch.classList.add("cart-drawer-card__swatch--active");

  // Hidden variant id (quick add form)
  var input = card.querySelector(".product-variant-id");
  if (input) input.value = swatch.dataset.variantId;

  // Image (handles both plain <img> and <picture><source>)
  var img = card.querySelector(".product-card-sm__img img");
  if (img && swatch.dataset.image) {
    var picture = img.closest("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach(function (s) {
        s.srcset = swatch.dataset.image;
      });
    }
    img.src = swatch.dataset.image;
    img.srcset = "";
  }

  // Links (image + title)
  if (swatch.dataset.url) {
    card.querySelectorAll("[data-swatch-link]").forEach(function (a) {
      a.href = swatch.dataset.url;
    });
  }

  // Price (swap in the pre-rendered price markup for this variant)
  var priceTemplate = card.querySelector(
    'template[data-price-template][data-variant-id="' +
      swatch.dataset.variantId +
      '"]',
  );
  var priceContainer = card.querySelector(".cart-drawer-card__price");
  if (priceTemplate && priceContainer) {
    priceContainer.innerHTML = priceTemplate.innerHTML;
  }
});

document.addEventListener("click", function (event) {
  const checkoutBtn = event.target.closest("#CartDrawer-Checkout");

  if (!checkoutBtn || checkoutBtn.classList.contains("loading")) return;

  checkoutBtn.classList.add("loading");

  // If checkout navigation doesn't happen, restore the button.
  setTimeout(() => {
    checkoutBtn.classList.remove("loading");
  }, 3000);
});

/* a-b test Magnetic Wall Boards - challengers - ab test - all devices */

// /**
//  * assets/nav-collection-link.js — A/B test: header nav link change.
//  * Flicker-safe + handles late-mounted (lazy-loaded) drawer/menu nodes.
//  */
// (function () {
//   var NEW_TEXT = 'Magnetic Wall Board';
//   var OLD_PATH = 'products/magnetic-wall-board-brown-sugar';
//   var NEW_PATH = 'collections/multifunctional-wall-decal';
//   var OLD_TITLE = 'Get Magnetic Wall Board';

//   var DESKTOP_SELECTOR = 'li.list-menu__items[data-title="' + OLD_TITLE + '"]';
//   var MOBILE_SELECTOR = '#HeaderDrawer-get-magnetic-wall-board';

//   // 1) Hide targets immediately via a synchronous <style> tag, before
//   //    the browser paints them.

//   function updateLink(anchor, textEl) {
//     if (!anchor) return;
//     var href = anchor.getAttribute('href') || '';
//     // Direct string replace — whatever locale/market prefix is already
//     // on the href (e.g. /en-chf/, /en-us/, /de/) is preserved untouched,
//     // since we only swap the OLD_PATH segment for NEW_PATH.
//     if (href.indexOf(OLD_PATH) !== -1) {
//       anchor.setAttribute('href', href.replace(OLD_PATH, NEW_PATH));
//     } else {
//       // Fallback: href didn't match the expected old path — log so it's
//       // noticeable in QA instead of silently failing.
//       console.warn('[nav-collection-link] Unexpected href, no replace made:', href);
//     }
//     if (textEl) textEl.textContent = NEW_TEXT;
//   }

//   function tryUpdateDesktop() {
//     var desktopLi = document.querySelector(DESKTOP_SELECTOR);
//     if (!desktopLi) return false;
//     updateLink(desktopLi.querySelector('a'), desktopLi.querySelector('.list-menu__item-text'));
//     desktopLi.setAttribute('data-title', NEW_TEXT);
//     return true;
//   }

//   function tryUpdateMobile() {
//     var mobileAnchor = document.querySelector(MOBILE_SELECTOR);
//     if (!mobileAnchor) return false;
//     updateLink(mobileAnchor, mobileAnchor.querySelector('span'));
//     return true;
//   }

//   var desktopDone = tryUpdateDesktop();
//   var mobileDone = tryUpdateMobile();

//   // 2) Watch for late-mounted (lazy-loaded) nav/drawer nodes.
//   if (!desktopDone || !mobileDone) {
//     var observer = new MutationObserver(function () {
//       if (!desktopDone) desktopDone = tryUpdateDesktop();
//       if (!mobileDone) mobileDone = tryUpdateMobile();
//       if (desktopDone && mobileDone) observer.disconnect();
//     });
//     observer.observe(document.documentElement, { childList: true, subtree: true });

//     setTimeout(function () {
//       observer.disconnect();
//       document.querySelectorAll(DESKTOP_SELECTOR + ', ' + MOBILE_SELECTOR)
//         .forEach(function (el) { el.style.visibility = ''; });
//     }, 10000);
//   }
// })();
/* a-b test Magnetic Wall Boards - challengers - ab test - all devices */

// Update Internal Links to Preserve the Current Country Version 08-09-2026
document.addEventListener("DOMContentLoaded", () => {
  const currentPath = window.location.pathname;
  const match = currentPath.match(/^\/([a-z]{2,3}-[a-z]{2,3})(?:\/|$)/i);

  const localePrefix = match ? `/${match[1]}` : "";

  document.querySelectorAll("a[href]").forEach((link) => {
    const href = link.getAttribute("href");

    if (!href) return;

    if (href.startsWith("//")) return;

    let url;

    try {
      url = new URL(href, window.location.origin);
    } catch {
      return;
    }
        // Don't modify anchor/hash links such as:
    // https://tix-mix.com/#looxReviewsFrame
    if (url.hash) return;

    if (url.hostname !== window.location.hostname) {
      return;
    }

    url.pathname = url.pathname.replace(
      /^\/[a-z]{2,3}-[a-z]{2,3}(?=\/|$)/i,
      "",
    );

    if (localePrefix) {
      url.pathname = localePrefix + url.pathname;
    }

    link.setAttribute("href", url.href);
  });
});
// Update Internal Links to Preserve the Current Country Version 08-09-2026
